import { useEffect, useState } from 'react';
import { useSigninCheck, useAuth } from 'reactfire';
import { useHistory } from 'react-router-dom';
import { signInWithCustomToken, inMemoryPersistence } from 'firebase/auth';

export const CLAIMS_KEY = Symbol('claims');

const useImpersonateStyles = (token: string) => {
  useEffect(() => {
    if (token) {
      document.body.classList.add('impersonate');
    }
  }, [token]);
};

export const useInitialUserDetection = () => {
  const auth = useAuth();
  const history = useHistory();
  const { status, data } = useSigninCheck({
    // This is the only way to get the claims from the auth library synchronously.
    validateCustomClaims: (claims) => {
      return {
        hasRequiredClaims: true,
        errors: {
          [CLAIMS_KEY]: claims,
        },
      };
    },
  });
  const impersonate = location.pathname.match(/impersonate\/(.*)/);
  const token = impersonate?.[1];

  const [impersonateLoading, setImpersonateLoading] = useState(
    () => !!impersonate,
  );

  useImpersonateStyles(token);

  useEffect(() => {
    const run = async () => {
      try {
        await auth.setPersistence(inMemoryPersistence);
        await signInWithCustomToken(auth, token);

        history.replace('/');
      } catch (error) {
        console.error(error);
      } finally {
        setImpersonateLoading(false);
      }
    };

    if (token) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      run();
    }
  }, [token, auth, history]);

  return {
    status: impersonateLoading ? 'loading' : status,
    data,
  };
};
